import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ThemeMode = 'light' | 'dark';
export type BrandType = 'standard' | 'lf';

interface IframeParamsState {
  theme: ThemeMode;
  brand: BrandType;
  tenantId: string | null;
  clientId: string | null;
  premiumSourceUrl: string | null;
  isInitialized: boolean;
}

const initialState: IframeParamsState = {
  theme: 'light',
  brand: 'standard',
  tenantId: null,
  clientId: null,
  premiumSourceUrl: null,
  isInitialized: false,
};

const iframeParamsSlice = createSlice({
  name: 'iframeParams',
  initialState,
  reducers: {
    setIframeParams(state, action: PayloadAction<Partial<IframeParamsState>>) {
      return { ...state, ...action.payload, isInitialized: true };
    },
    setTheme(state, action: PayloadAction<ThemeMode>) {
      state.theme = action.payload;
    },
    resetIframeParams() {
      return initialState;
    },
  },
});

export const { setIframeParams, setTheme, resetIframeParams } = iframeParamsSlice.actions;
export default iframeParamsSlice.reducer;
